import { useCallback } from 'react';
import { SelectModalParams } from '~/types';
import { enableScrollLock, disableScrollLock } from '~/utils';
import { useSelectModalStore } from '~/store';

const useSelectModal = () => {
  const setModalState = useSelectModalStore((state) => state.setModalState);

  const openSelectModal = useCallback(
    ({
      click,
      selectOptions,
      selectedOption,
      modalTitle,
    }: SelectModalParams) => {
      setModalState({
        modalTitle,
        selectedOption,
        isOpen: true,
        selectOptions,
        click,
      });
      enableScrollLock();
    },
    [setModalState],
  );

  const closeSelectModal = useCallback(() => {
    setModalState({
      modalTitle: '',
      isOpen: false,
      selectOptions: [],
      click: (option: string) => {
        console.log(`Modal closed, no action for option: ${option}`);
      },
    });
    disableScrollLock();
  }, [setModalState]);

  return { openSelectModal, closeSelectModal };
};

export default useSelectModal;
